const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://coupon.ioyou.co.jp';

export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/api/login`,
  FORGOT_PASSWORD: `${API_BASE_URL}/api/forgot-password`,
  VERIFY_PASSCODE: `${API_BASE_URL}/api/verify-passcode`,
  RESET_PASSWORD: `${API_BASE_URL}/api/reset-password`,
  CHANGE_PASSWORD: `${API_BASE_URL}/api/change-password`,
  PROFILE: (id) => `${API_BASE_URL}/api/manager/update/${id}`,

  ADMIN_CLIENTS: `${API_BASE_URL}/api/admin/clients`,
  ADMIN_CLIENT_BLOCK: (id) => `${API_BASE_URL}/api/admin/clients/${id}/block`,
  ADMIN_CLIENT_UNBLOCK: (id) => `${API_BASE_URL}/api/admin/clients/${id}/unblock`,
  ADMIN_CLIENT: (id) => `${API_BASE_URL}/api/admin/clients/${id}`,

  ADMIN_COUPON_TYPES: `${API_BASE_URL}/api/admin/coupon-types`,
  ADMIN_COUPON_TYPE: (id) => `${API_BASE_URL}/api/admin/coupon-types/${id}`,
  ADMIN_COUPON_TYPE_FLAGSHIP: (id) => `${API_BASE_URL}/api/admin/coupon-types/${id}/flagship`,

  ADMIN_COUPONS: `${API_BASE_URL}/api/admin/coupons`,

  ISSUED_COUPONS: `${API_BASE_URL}/api/issued-coupons`,
  ISSUED_COUPONS_GET_ALL: `${API_BASE_URL}/api/coupons`,
  COUPONS_GET_QR: `${API_BASE_URL}/api/coupons/export-qr`,
  COUPONS_DELETE_BATCH: `${API_BASE_URL}/api/coupons/delete-batch`,

  CLIENT_COUPON_TYPES: `${API_BASE_URL}/api/client/coupon-types/public`,

  ADMIN_ANNOUNCEMENTS: `${API_BASE_URL}/api/admin/announcements`,
  ADMIN_ANNOUNCEMENT: (id) => `${API_BASE_URL}/api/admin/announcements/${id}`,
  ADMIN_HEALTHTRON_USERS: `${API_BASE_URL}/api/admin/healthtron-users`,
  ADMIN_HEALTHTRON_USER_STATS: `${API_BASE_URL}/api/admin/healthtron-users/stats`,

  ANNOUNCEMENTS_ACTIVE: (target = 'coupon') =>
    `${API_BASE_URL}/api/announcements/active?target=${target}`,
};

export default API_BASE_URL;
